import { useCurrentRefinements } from 'react-instantsearch'

export const useCurrentNumberOfFilters = () => {
  const { items } = useCurrentRefinements()

  const defaultReleaseDateFilter = items.find(
    item =>
      item.attribute === 'releaseDateYear' &&
      item.refinements[0].value === 1980 &&
      item.refinements[1].value === new Date().getFullYear()
  )
  const defaultPriceRangeFilter = items.find(
    item =>
      item.attribute === 'lowestAsk' &&
      item.refinements[0].value === 0 &&
      !item.refinements[1]
  )
  const defaultEntityFilter = items.find(item => item.attribute === 'entity')

  // -1 for isDelete item
  return (
    items.length -
    1 -
    (defaultReleaseDateFilter ? 1 : 0) -
    (defaultPriceRangeFilter ? 1 : 0) -
    (defaultEntityFilter ? 1 : 0)
  )
}
